import React, { useEffect, useState } from 'react';
export function TopBanner() {
  // Start at 14:59 (899 seconds)
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const mins = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const secs = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-black text-white py-3 px-4 shadow-md" data-id="element-310">
      <div className="max-w-4xl mx-auto flex items-center justify-center text-center text-sm sm:text-base font-bold tracking-wide" data-id="element-311">
        <span data-id="element-312">
          🔥 OFERTA ÚNICA: $9.95 USD (Reg. $27) · TERMINA EN:{' '}
          <span className="text-brand-gold ml-1 font-mono text-lg" data-id="element-313">
            {mins}:{secs}
          </span>
        </span>
      </div>
    </div>;
}